
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeaderPrincipal',
  props: {
    // Custom subtitle for specific pages
    subtitle: {
      type: String,
      default: ''
    },
    // Show user type indicator
    showUserType: {
      type: Boolean,
      default: false
    },
    // Force a specific background color
    customBackgroundColor: {
      type: String,
      default: ''
    },
    // Show secondary logo
    showSecondaryLogo: {
      type: Boolean,
      default: true
    },
    // Compact mode for smaller header
    compact: {
      type: Boolean,
      default: false
    },
    // Extended background (acts like FondoDiagonal)
    extendedBackground: {
      type: Boolean,
      default: false
    },
    // Show floating decorative elements
    showFloatingElements: {
      type: Boolean,
      default: false
    },
    // Show diagonal overlay effect
    showDiagonalEffect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerBackgroundColor(): string {
      if (this.customBackgroundColor) {
        return this.customBackgroundColor;
      }

      // Get color from store or default
      const storeColor = this.$store?.getters?.colorPlan;
      if (storeColor && storeColor.includes('var(')) {
        // Convert CSS variables to actual colors
        const colorMap: Record<string, string> = {
          'var(--azul-institucional)': '#375282',
          'var(--verde-institucional)': '#40b99d',
          'var(--celeste-institucional)': '#56c0e8',
          'var(--azul-enfermeria)': '#273470',
          'var(--rojo-obstetricia)': '#AB2326',
          'var(--verde-agronomia)': '#639244',
          'var(--verde-forestal)': '#136E49',
          'var(--naranjo-industrial)': '#F06A26',
          'var(--amarillo-social)': '#F9b81C',
          'var(--celeste-psicologia)': '#00ACB4',
          'var(--rosado-informatica)': '#D60B51',
          'var(--verde-terapia-ocupacional)': '#336666',
          'var(--azul-ing-comercial)': '#006699',
          'var(--naranjo)': '#f27c08'
        };

        const color = colorMap[storeColor] || '#375282';
        return `linear-gradient(135deg, ${color}, ${color}dd)`;
      }

      return storeColor || 'linear-gradient(135deg, #375282, #375282dd)';
    },

    wavesImage(): string {
      // Use different waves based on user type
      if (this.$store?.getters?.esPostulanteEduCont) {
        return require('@/assets/img/olas_azules.png');
      }
      return require('@/assets/img/olas_celestes.png');
    },

    secondaryLogoImage(): string {
      // Different secondary logo based on user type
      if (this.$store?.getters?.esPostulanteEduCont) {
        return require('@/assets/img/logos/logo-uaysen_patagonia_blanco_sin_fondo.png');
      }
      return require('@/assets/img/logos/web_nuevos1.png');
    },

    userTypeText(): string {
      if (this.$store?.getters?.esPostulante) {
        return 'Postulante';
      }
      if (this.$store?.getters?.esEstudianteAntiguo) {
        return 'Estudiante';
      }
      if (this.$store?.getters?.esPostulanteEduCont) {
        return 'Educación Continua';
      }
      return '';
    },

    logoSize(): string {
      if (this.compact) {
        return 'w-16 md:w-20 lg:w-24 h-auto';
      }
      return 'w-20 md:w-24 lg:w-28 xl:w-32 h-auto';
    },

    wavesPosition(): string {
      return [
        'top-2 md:top-4 lg:top-6',
        'w-16 md:w-20 lg:w-24',
        'h-8 md:h-10 lg:h-12',
      ].join(' ');
    },

    secondaryLogoPosition(): string {
      return [
        'top-4 md:top-6 lg:top-8',
        'right-4 md:right-8 lg:right-12',
        'w-20 md:w-24 lg:w-28 xl:w-32',
        'h-auto',
        'hidden lg:block',
      ].join(' ');
    }
  }
});
